//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    name: 'rollbox',
    inheritAttrs: true,
    props: {
        data: {
            default: function(data){
                return [];
            },
            type: Array,
        },
        speed: {
            default: 1000,
            type: Number,
        }
    },
    data(){
        return {
            handle: null,
            countNum: 0,
            sClose: false,
            vnode: null,
            rowHeight: '',
        }
    },
    filters: {

    },
    methods: {

        interval(){
            clearTimeout(this.handle);
            this.handle = setTimeout(()=>{
                if(this.$slots.default.length<=1 || this.sClose){
                    clearTimeout(this.handle);
                    return;
                }
                this.rowHeight = this.countLineHeight();
                this.countNum = this.countNum >= this.vnode.length-1 ? 0 : this.countNum+1;
                this.interval();
            },this.speed)
        },

        countLineHeight(){

            if(!this.$slots.default)
                return 0;

            let node = this.$slots.default.filter((val)=>val.tag && val);
            this.vnode = node;

            if(node.length<1)
                return 0;

            return node[0].elm.offsetHeight;
        }

    },

    mounted(){
        this.rowHeight = this.countLineHeight();
        this.interval();
    },

    destroyed(){
        this.sClose = true;
        clearTimeout(this.handle);
    }
}



// WEBPACK FOOTER //
// ./src/components/ui/rollBox.vue